import React from 'react'
import { message } from 'antd'
import PageLayout from '@layouts/PageLayout'
import { useHistory } from 'react-router-dom'
import { useLocalization } from '@contexts/LocalizationContext'
import FormComponent from './Form'
import { client } from '@utils/client'

const Create = () => {
  const { t } = useLocalization()
  const history = useHistory()
  const handleSubmit = async (data) => {
    try {
      await client.post('/article', data)
      message.success('สำเร็จ')
      history.push('/articles')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <PageLayout title={t('article.createScreen.title')} extra={[]}>
      <FormComponent handleSubmit={handleSubmit} />
    </PageLayout>
  )
}

export default Create
